import { NotificationType } from "./enum";
// import { GLGlobal } from "./utility";
//import { GLLocale } from "@gl-commonui/locales/localeid";
import { notification, Icon, Modal } from "ant-design-vue";
import { VNode } from "vue/types/umd";
import { ModalOptions } from "ant-design-vue/types/modal";
import { fmtMsg } from ".";
import { CommonLocale } from "@/locales/localeid";
export class MessageHelper {
	static Message(type: NotificationType, message: string) {
		let title, icontype: string, color: string;
		switch (type) {
			case NotificationType.Warning:
				icontype = "exclamation-circle";
				color = "#F7931E";
				title = fmtMsg(CommonLocale.CommonWarningTitle);
				break;
			case NotificationType.Success:
				icontype = "check-circle";
				color = "#52c41a";
				title = fmtMsg(CommonLocale.CommonSuccessTitle);
				break;
			case NotificationType.Failed:
				icontype = "close-circle";
				color = "#f5222d";
				title = fmtMsg(CommonLocale.CommonFailedTitle);
				break;
		}

		notification.open({
			message: title,
			duration: 3,
			description: message,
			icon: (h) => h(Icon, { props: { type: icontype } })
			//icon: <Icon type={icontype} style={{ color: color }} theme="filled" />,
		});
	}

	static ShowError(error?: { error: string; error_description: string; error_code: string }) {
		if (!error) {
			return;
		}
		MessageHelper.Message(NotificationType.Failed, error.error_description);
	}

	static Confirm(content: string | VNode, onOk: any, onCancel: any = null, okText = null, cancelText = null) {
		const textOk = okText || "Yes";
		const textCancel = cancelText || "No";

		Modal.confirm({
			content: (h) => h("div", { class: "messagehelper__confirm--content" }, content),
			onOk: onOk,
			onCancel: onCancel,
			okText: textOk,
			cancelText: textCancel
		} as ModalOptions);
	}
}
